<template>
  <div
    class="upsell-hero flex w-full flex-col items-center gap-4 text-center"
    data-testid="upsell-hero"
  >
    <UpsellGateBadge :text="badgeText" />
    <OwnType
      class="upsell-hero__title"
      :text="title"
      variant="heading-regular"
      align="center"
    />
    <OwnType
      v-if="description"
      class="upsell-hero__description"
      :text="description"
      variant="paragraph-regular"
      align="center"
    />
    <img
      class="upsell-hero__phone"
      :src="heroPhones"
      alt=""
      data-testid="upsell-hero-phone"
    />
  </div>
</template>

<script lang="ts" setup>
import { OwnType } from '@/ui/OwnType'

import heroPhones from '../assets/hero-gate-web.png'

import UpsellGateBadge from './UpsellGateBadge.vue'

withDefaults(
  defineProps<{
    badgeText?: string
    description?: string
    title: string
  }>(),
  {
    badgeText: undefined,
    description: undefined,
  }
)
</script>

<style lang="scss" scoped>
// Light hero from the tier-upgrades design (Figma node 806:46646): badge,
// title, and subtitle stacked over the hero-phone artwork.
.upsell-hero {
  &__title {
    max-width: 420px;
    font-weight: 500;
  }

  &__phone {
    width: 100%;
    max-width: 760px;
  }

  &__description {
    max-width: 460px;
  }
}
</style>
